import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import * as Yup from 'yup'
import Box from '../../../../Global/Box'
import PreviewFormField from '../../Forms/componets/previewForm/PreviewFormField'
import { GET_ONE_FORM_BY_ID } from '../../../../../graphql/Catalog/Forms/forms'
import { GET_DATA_SOURCE_CHOOSEN } from '../../../../../graphql/Catalog/Forms/formFieldTypeChoosenSource'

export const ShowFormDynamic = ({
  formId,
  control,
  setValidationSchemaRules,
  onChangeFile = () => {},
  onChangeFileImg = () => {},
  handleRemoveFile = () => {},
}) => {
  const [data, setData] = useState(null)
  const [maxFiles, setMaxFiles] = useState(1)

  //USEQUERY:
  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_ONE_FORM_BY_ID, {
    variables: {
      formId: parseInt(formId),
    },
    fetchPolicy: 'no-cache',
  })

  //MUTATION:
  const [getDataSource] = useMutation(GET_DATA_SOURCE_CHOOSEN)

  //FUNCTIONS:
  const processBuildingRules = async ({
    typeYup,
    typeField,
    fieldYupRules,
  }) => {
    let schema = null
    if (typeYup === 'file' && typeField === 'file') {
      schema = Yup.string()
    } else if (typeYup === 'file' && typeField === 'image') {
      schema = Yup.array().nullable()
    } else {
      schema = Yup[typeYup]()
    }

    for (const fieldYupRule of fieldYupRules) {
      const yupRuleOfField = fieldYupRule.YupRuleOfField

      console.log({yupRuleOfField})

      if (!yupRuleOfField) continue

      switch (yupRuleOfField.yup_rule) {
        case 'required':
          if (!yupRuleOfField.active_on_web)
            schema = schema.required(yupRuleOfField?.message)
          break
        case 'min':
          schema = schema.min(
            parseInt(yupRuleOfField?.options),
            yupRuleOfField?.message
          )
          break
        case 'max':
          schema = schema.max(
            parseInt(yupRuleOfField?.options),
            yupRuleOfField?.message
          )
          if (typeField === 'image')
            setMaxFiles(parseInt(yupRuleOfField?.options))
          break
        case 'email':
          schema = schema.email(yupRuleOfField?.message)
          break
        case 'matches':
          schema = schema.matches(
            yupRuleOfField?.options,
            yupRuleOfField?.message
          )
          break
        default:
          break
      }
    }

    return schema
  }

  const processingDataReceived = async (dataRespProc) => {
    let dataFieldsOfForm = []
    let validationSchemaField = {}

    for await (let field of dataRespProc.FieldsOfForm) {
      let choosenSourceData = null
      if (
        field.TypeOfField.name === 'choosen_db' &&
        field.field_type_choosen_source_id
      ) {
        const { data } = await getDataSource({
          variables: {
            idFormFieldTypeChoosenSource: parseInt(
              field.field_type_choosen_source_id
            ),
          },
        })
        choosenSourceData = data.getDataSourceOfFormFieldTypeChoosenSource
      }

      console.log({field})
      if (field.FieldYupRulesOfFormField.length > 0) {
        const schema = await processBuildingRules({
          typeYup: field.TypeOfField.type,
          typeField: field.TypeOfField.name,
          fieldYupRules: field.FieldYupRulesOfFormField,
        })
        validationSchemaField[field.name] = schema
      }

      dataFieldsOfForm.push({ ...field, choosenSourceData })
    }
    setValidationSchemaRules((old) => ({ ...old, ...validationSchemaField }))
    setData({ ...dataRespProc, FieldsOfForm: dataFieldsOfForm })
  }

  //EFECTS
  useEffect(() => {
    if (!loading && !error) {
      if (dataResp?.getOneFormById) {
        processingDataReceived(dataResp.getOneFormById)
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataResp, loading, error])

  return (
    <>
      {data && (
        <Box
          withCard={false}
          title={`${data.diplay_name}`}
          content={
            <>
              <div className="row">
                <PreviewFormField
                  control={control}
                  fieldsData={data?.FieldsOfForm}
                  onChangeFile={onChangeFile}
                  onChangeFileImg={onChangeFileImg}
                  removeFile={handleRemoveFile}
                  maxFiles={maxFiles}
                  newDropAttachment={true}
                />
              </div>
            </>
          }
        />
      )}
    </>
  )
}

export default React.memo(ShowFormDynamic)
